export default {
  '478': '验证码错误,请重新输入',
  '479': '演示环境，没有权限操作',
  '401': '当前操作没有权限',
  '403': '当前操作没有权限',
  '400': '用户名不存在或密码错误',
  'default': '服务异常，请重试'
}



// WEBPACK FOOTER //
// ./src/const/errorCode.js